export const goalSettingOutlet = 'goal-setting';
